
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration/application_photo/[show]",
      function () {
        return require("private-next-pages/inspiration/application_photo/[show].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration/application_photo/[show]"])
      });
    }
  